export default "__VITE_ASSET__536a3501__"